var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { theme } from '../../theme';
import { IconClose } from '../../atoms/icons/16x16/Close';
import { IconTick } from '../../atoms/icons/16x16/Tick';
import { randomString } from '../../utils/randomString';
import { ToggleStyles } from './ToggleStyles';
export var Toggle = function (_a) {
    var className = _a.className, onChange = _a.onChange, _b = _a.defaultValue, defaultValue = _b === void 0 ? false : _b, _c = _a.dataCy, dataCy = _c === void 0 ? 'toggle-input' : _c, _d = _a.tabFocusTrap, tabFocusTrap = _d === void 0 ? 0 : _d;
    var _e = useState(defaultValue), active = _e[0], setActive = _e[1];
    var _f = useState(false), focused = _f[0], setFocused = _f[1];
    var idRef = useRef(randomString());
    var handleOnChange = function () {
        setActive(!active);
        onChange(!active);
    };
    return (_jsx(ToggleStyles, __assign({ id: idRef.current, className: className, active: active, onClick: handleOnChange, focused: focused }, { children: _jsxs("div", __assign({ className: "input-wrapper ".concat(active ? 'active' : ''), "data-cy": dataCy }, { children: [_jsx("span", __assign({ className: "svg ".concat(active ? ' active ' : '') }, { children: !active ? (_jsx(IconClose, { fill: theme.primaryColours.white.main })) : (_jsx(IconTick, { fill: theme.primaryColours.white.main })) })), _jsx("input", { className: "checkbox-hidden", type: "checkbox", checked: active, onBlur: function () { return setFocused(false); }, onFocus: function () { return setFocused(true); }, "data-cy": dataCy, onClick: function () { return handleOnChange(); }, "aria-labelledby": idRef.current, tabIndex: tabFocusTrap })] })) })));
};
